module.exports = __webpack_public_path__ + "static/img/9.8662704.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/snip3down/9.png
// module id = snFb
// module chunks = 35